import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams } from "react-router-dom";
import { decodeToken, getToken } from "../../utils/TokenUtils";
import { API_URL, ENDPOINTS } from "../../constants/api";
import axios from "axios";

const PassCard2 = () => {
  const { id, route, exam_id } = useParams();
  const token = getToken();
  const banner = decodeToken(token, "banner");
  const logo = decodeToken(token, "logo");
  const user_id = decodeToken(token, "id");

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/${route}`;
        const response = await axios.post(
          url,
          { student_id: id, exam_id, user_id },
          { headers: { Authorization: token ? `Bearer ${token}` : "" } }
        );
        setData(response.data?.data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (route) fetchData();
  }, [route, id, exam_id, user_id, token]);

  useEffect(() => {
    if (data.length > 0) {
      const timer = setTimeout(() => window.print(), 800);
      return () => clearTimeout(timer);
    }
  }, [data]);

  if (!data.length) return null;
 
    

   

  const d = data[0];
  const filteredData = Object.entries(d).filter(([key]) => !key.startsWith("_")); 

const getDayWithSup = (day) => {
  const j = day % 10,
        k = day % 100;
  let suffix = "th";
  if (j === 1 && k !== 11) suffix = "st";
  else if (j === 2 && k !== 12) suffix = "nd";
  else if (j === 3 && k !== 13) suffix = "rd";
  return { day, suffix };
};


const formatDateWithSup = (dateStr) => {
  const date = new Date(dateStr);
  const { day, suffix } = getDayWithSup(date.getDate());
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  return { day, suffix, month, year };
};


const fromDate = formatDateWithSup(d._valid_from);
const toDate = formatDateWithSup(d._valid_to);


  // Optional: ensure at least 5 rows to avoid UI crash
  while (filteredData.length < 6) filteredData.push(["", ""]);

  return (
    <div className="d-flex" style={{ height: "500px", margin: "25px", padding: "25px" }}>
      <div
        style={{
          width: "100%",
          border: "2px solid #000",
          borderRadius: "5px",
          backgroundColor: "#fff",
          padding: "25px",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <center>
          <img
            src={`${API_URL}/${banner}`}
            alt="School Banner"
            style={{
              width: "100%",
              height: "80px",
              borderRadius: "15px",
              objectFit: "fill",
            }}
          />
        </center>

        <div
          style={{
            textAlign: "center",
            marginTop: "10px",
            color: "#016382",
            fontWeight: "bold",
            display:"flex",
            justifyContent:"space-around",
            textTransform: "uppercase",
          }}
        >
          <div>{d._academic_year}</div>
          <div>{d._title}</div>
          <div>{d._exam_type}</div>
        </div>
           <div style={{textAlign:"center",padding:"10px", color: "#016382",}}> -THIS CARD CERTIFIED THAT</div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
         
          <div style={{ flex: 1, paddingRight: "20px" }}>
            <div style={{ padding: "15px 25px", fontSize: "18px", lineHeight: "1.8" }}>
              <table className="table table-bordered" style={{ fontSize: "21px", fontWeight: "bolder" }}>
                <thead>
                  <tr>
                    <th>{filteredData[0][0]}</th>
                    <th colSpan={3}>{filteredData[0][1]}</th>
                    <th colSpan={3}>{filteredData[1][0]}: {filteredData[1][1]}</th>
                  </tr>
                  <tr>
                    <th>{filteredData[2][0]}</th>
                    <th>{filteredData[2][1]}</th>
                    <th>{filteredData[3][0]}</th>
                    <th>{filteredData[3][1]}</th>
                    <th>{filteredData[4][0]}</th>
                    <th>{filteredData[4][1]}</th>
                  </tr>

                </thead>
            
              </table>

             <div style={{ textAlign: "center", fontSize: "17px",color:"black", marginTop: "10px" }}>
  Valid from <b>{fromDate.day}<sup>{fromDate.suffix}</sup> {fromDate.month}, {fromDate.year}</b>
  {" "}to <b>{toDate.day}<sup>{toDate.suffix}</sup> {toDate.month}, {toDate.year}</b>
</div>
            </div>

            <p style={{ marginTop: "10px", fontWeight: "bold",color:"black", fontSize: "17px", textAlign: "center" }}>
              {d._description}
            </p>
          </div>
        </div>
      </div>
 


      {/* Right Side Profile Box */}
      <div
        style={{
          width: "230px",
          textAlign: "center",
          border: "2px solid #000",
          paddingLeft: "15px",
          borderRadius: "5px",
        }}
      >
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "10px",
            color: "green",
            fontWeight: "bolder",
            padding: "5px 10px",
            fontSize: "17px",
            marginBottom: "10px",
          }}
        >
          {d._exam_type}
        </div>

        <div
          style={{
            width: "190px",
            height: "190px",
            borderRadius: "50%",
            overflow: "hidden",
            border: "3px solid #ddd",
            margin: "0 auto 15px auto",
          }}
        >
          <img
            src={`${API_URL}/${d._photo}`}
            alt="Student"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </div>

        <div style={{ fontWeight: "bold", fontSize: "16px", marginTop: "5px", color: "green" }}>
          {d._Date} <br />
          <span style={{ fontWeight: "normal" }}>{d.User}</span>
          <p style={{ color: "green" }}>____________________</p>
        </div>
      </div>
    </div>
  );
};

export default PassCard2;
